import React, { useState, useEffect } from 'react';

export default function Community() {
    // 1. Inisialisasi State dari LocalStorage agar tidak hilang saat refresh
    const [posts, setPosts] = useState(() => {
        const savedPosts = localStorage.getItem('xyrons_posts');
        return savedPosts ? JSON.parse(savedPosts) : [
            {
                id: 1,
                user: "Rony Saputra",
                content: "Baru saja mencoba render desain kamar cowok pakai Planner 5D + Midjourney. Hasilnya gokil!",
                time: "2h ago",
                likes: 12
            }
        ];
    });

    const [inputText, setInputText] = useState("");

    // 2. Simpan ke LocalStorage setiap kali ada perubahan pada posts
    useEffect(() => {
        localStorage.setItem('xyrons_posts', JSON.stringify(posts));
    }, [posts]);

    // Fungsi Tambah Postingan Baru
    const handlePost = () => {
        if (!inputText.trim()) return;

        const newPost = {
            id: Date.now(), // ID unik berdasarkan waktu
            user: "Guest User", // Bisa diganti sesuai login
            content: inputText,
            time: "Just now",
            likes: 0
        };

        setPosts([newPost, ...posts]);
        setInputText(""); // Kosongkan input
    };

    // Fungsi Like Live
    const handleLike = (id) => {
        const updatedPosts = posts.map(post => {
            if (post.id === id) {
                return { ...post, likes: post.likes + 1 };
            }
            return post;
        });
        setPosts(updatedPosts);
    };

    return (
        <div style={styles.container}>
            <header style={styles.header}>
                <h1 style={styles.title}>XYRONS COMMUNITY</h1>
                <p style={styles.subtitle}>Tempat berbagi inspirasi AI dan Masa Depan.</p>
            </header>

            <div style={styles.feed}>
                {/* Input Box */}
                <div style={styles.postBox}>
                    <div style={styles.avatarMini}></div>
                    <input
                        type="text"
                        placeholder="Apa yang kamu pikirkan?"
                        style={styles.input}
                        value={inputText}
                        onChange={(e) => setInputText(e.target.value)}
                        onKeyPress={(e) => e.key === 'Enter' && handlePost()}
                    />
                    <button onClick={handlePost} style={styles.btnPost}>Kirim</button>
                </div>

                {/* List Postingan */}
                {posts.map(post => (
                    <div key={post.id} style={styles.postCard}>
                        <div style={styles.postHeader}>
                            <div style={styles.avatarMini}></div>
                            <div>
                                <h4 style={styles.userName}>{post.user}</h4>
                                <span style={styles.time}>{post.time}</span>
                            </div>
                        </div>
                        <p style={styles.postContent}>{post.content}</p>
                        <div style={styles.actions}>
                            <span onClick={() => handleLike(post.id)} style={styles.actionItem}>
                                ❤️ {post.likes} Likes
                            </span>
                            <span style={styles.actionItem}>💬 Komentar</span>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}

const styles = {
    container: { padding: '20px', maxWidth: '700px', margin: '0 auto', color: '#fff', fontFamily: 'Inter, sans-serif' },
    header: { marginBottom: '40px', textAlign: 'left' },
    title: { fontSize: '32px', color: '#00d2ff', fontWeight: '900', letterSpacing: '-1px' },
    subtitle: { color: '#666', fontSize: '15px' },
    feed: { display: 'flex', flexDirection: 'column', gap: '20px' },
    postBox: { background: '#0a0a0a', padding: '20px', borderRadius: '24px', border: '1px solid #1a1a1a', display: 'flex', alignItems: 'center', gap: '15px' },
    input: { flex: 1, background: 'transparent', border: 'none', color: '#fff', outline: 'none', fontSize: '15px' },
    btnPost: { background: '#00d2ff', color: '#000', border: 'none', padding: '10px 25px', borderRadius: '12px', fontWeight: '800', cursor: 'pointer' },
    postCard: { background: '#0a0a0a', padding: '25px', borderRadius: '24px', border: '1px solid #1a1a1a' },
    postHeader: { display: 'flex', alignItems: 'center', gap: '15px', marginBottom: '15px' },
    avatarMini: { width: '45px', height: '45px', borderRadius: '15px', background: 'linear-gradient(135deg, #00d2ff 0%, #3a7bd5 100%)' },
    userName: { margin: 0, fontSize: '16px', fontWeight: '700' },
    time: { fontSize: '12px', color: '#444' },
    postContent: { color: '#bbb', lineHeight: '1.6' },
    actions: { marginTop: '20px', display: 'flex', gap: '25px', fontSize: '13px', color: '#888', borderTop: '1px solid #151515', paddingTop: '15px' },
    actionItem: { cursor: 'pointer', transition: '0.2s', '&:hover': { color: '#00d2ff' } }
};